//
import { API } from "../../api";
async function sign_in(request) {
    // console.log("sign_in -> request", request);
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/user/sign/in`, //
        content: {
            ...request,
            client_id: process.env.LETS_TRADE_CLIENT_ID,
        },
    });
}
export { 
// ISignInRequest,
sign_in, };
